import { render, staticRenderFns } from "./AISearchAnalyticsDashboard.vue?vue&type=template&id=a2ff2f2c&scoped=true&"
import script from "./AISearchAnalyticsDashboard.vue?vue&type=script&lang=js&"
export * from "./AISearchAnalyticsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AISearchAnalyticsDashboard.vue?vue&type=style&index=0&id=a2ff2f2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ff2f2c",
  null
  
)

export default component.exports